var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCertificado01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1300",
    transform: "translate(2.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_884",
    d: "M31.5,10.6c-0.1-0.1-0.1-0.3-0.3-0.4L22,0.9c-0.2-0.2-0.5-0.3-0.8-0.3H6c-1.3,0-2.3,1-2.3,2.3v10.5 c0,0.6,0.5,1.2,1.2,1.2C5.5,14.5,6,14,6,13.3c0,0,0,0,0,0V2.9h14v7c0,1.3,1,2.3,2.3,2.3h7v18.6h-14c-0.6,0-1.2,0.5-1.2,1.2 c0,0.6,0.5,1.2,1.2,1.2c0,0,0,0,0,0h14c1.3,0,2.3-1,2.3-2.3V11C31.6,10.9,31.6,10.7,31.5,10.6z M22.3,9.9V4.5l5.3,5.3H22.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1302",
    transform: "translate(0 9.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_885",
    d: "M13.3,24.7l-1.8-7.2c2.3-2.2,2.4-5.9,0.2-8.2C9.5,6.9,5.9,6.8,3.5,9c-2.3,2.2-2.4,5.9-0.2,8.2 c0.1,0.1,0.1,0.1,0.2,0.2l-1.8,7.2c-0.2,0.6,0.2,1.3,0.8,1.4c0.3,0.1,0.6,0,0.8-0.1l4.1-2.1l4.1,2.1c0.2,0.1,0.3,0.1,0.5,0.1 c0.6,0,1.2-0.5,1.2-1.2C13.3,24.8,13.3,24.7,13.3,24.7L13.3,24.7z M8,21.6c-0.3-0.2-0.7-0.2-1,0l-2.4,1.2l1-4 c1.2,0.5,2.6,0.5,3.8,0l1,4L8,21.6z M7.5,16.8c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5 C11,15.2,9.4,16.8,7.5,16.8L7.5,16.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1304",
    transform: "translate(5.354 4.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_886",
    d: "M13.8,3.5h-7C6.2,3.5,5.7,4,5.7,4.7c0,0.6,0.5,1.2,1.2,1.2c0,0,0,0,0,0h7c0.6,0,1.2-0.5,1.2-1.2 S14.5,3.5,13.8,3.5C13.8,3.5,13.8,3.5,13.8,3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1306",
    transform: "translate(6.691 8.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_887",
    d: "M21.8,6.5h-14C7.2,6.5,6.7,7,6.6,7.6c0,0.6,0.5,1.2,1.2,1.2c0,0,0,0,0,0h14c0.6,0,1.2-0.5,1.2-1.2 C22.9,7,22.4,6.5,21.8,6.5L21.8,6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1308",
    transform: "translate(8.029 12.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_888",
    d: "M20.4,9.5H8.8c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2l0,0h11.6c0.6,0,1.2-0.5,1.2-1.2 C21.6,10,21.1,9.5,20.4,9.5L20.4,9.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCertificado01);
export default __webpack_public_path__ + "static/media/ico-certificado-01.474f65e9db1c9347a7b2f33807b962f0.svg";
export { ForwardRef as ReactComponent };